import React from 'react';
import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';
import { Box, Inline, Stack, Text, xcss } from '@atlaskit/primitives';
// eslint-disable-next-line workspaces/require-dependency
import PaypalIcon from '@css-xp/base/assets/img/paypal-icon.svg';
import './existing-paypal-payment-method.scss';

const paypalContainerWithBorderStyles = xcss({
  borderWidth: 'border.width',
  borderColor: 'color.border',
  borderStyle: 'solid',
  borderRadius: 'border.radius.100',
  padding: 'space.200',
  width: '100%',
});

const paypalContainerWithoutBorderStyles = xcss({
  // padding: 'space.200',
});

const iconContainerStyles = xcss({
  paddingInline: 'space.200',
  paddingBlock: 'space.050',
  borderWidth: 'border.width',
  borderColor: 'color.border',
  borderStyle: 'solid',
  borderRadius: 'space.100',
});

const IconContainer = styled.div<{ iconHeight?: number; iconWidth?: number }>`
  > img {
    padding: ${token('space.050')};
    border: 1px solid ${token('color.border')};
    border-radius: ${token('space.050')};
    width: ${(props) => props.iconWidth || '45px'};
    height: ${(props) => props.iconHeight || '30px'};
    box-sizing: border-box;
    display: inline-block;
    vertical-align: middle; // To vertically align the icon with the text
  }
`;

export type PaypalProps = {
  emailID?: string | null;
  withBorder?: boolean;
  renderChildrenInline?: boolean;
  isDesignIteration1Enabled?: boolean;
  iconHeight?: number;
  iconWidth?: number;
};

export const PaypalPanel: React.FC<PaypalProps> = ({ emailID }) => {
  return (
    <div className="paypalInfoPanel" data-testid="payment-selection-view-paypal">
      <div className="iconColumn">
        {/* @ts-ignore */}
        <img src={PaypalIcon} />
      </div>
      <div className="paypalAccountInfo">
        <div className="paypalHeader">PayPal</div>
        <div className="payPalText">{emailID}</div>
      </div>
    </div>
  );
};
const renderPaypalIcon = (iconHeight?: number, iconWidth?: number) => {
  if (iconHeight && iconWidth) {
    return (
      <>
        {/* @ts-ignore */}
        <img src={PaypalIcon} alt="paypal-icon" height={iconHeight} width={iconWidth} />
      </>
    );
  }

  return (
    <>
      {/* @ts-ignore */}
      <img src={PaypalIcon} alt="paypal-icon" />
    </>
  );
};

export const PaypalPanelWithPrimitives: React.FC<PaypalProps> = ({
  emailID,
  renderChildrenInline = false,
  withBorder = true,
  isDesignIteration1Enabled = false,
  iconHeight,
  iconWidth,
}) => {
  return (
    <Box xcss={withBorder ? paypalContainerWithBorderStyles : paypalContainerWithoutBorderStyles}>
      <Inline space="space.200" alignBlock="center">
        <Box>
          {isDesignIteration1Enabled ? (
            <IconContainer iconHeight={iconHeight} iconWidth={iconWidth}>
              {renderPaypalIcon(iconHeight, iconWidth)}
            </IconContainer>
          ) : (
            <Box xcss={iconContainerStyles} testId="icon-container-container" style={{ borderRadius: '4px' }}>
              {renderPaypalIcon(iconHeight, iconWidth)}
            </Box>
          )}
        </Box>
        {renderChildrenInline ? (
          <Inline space="space.100" alignBlock="center" testId="paypal-email-id-inline-container">
            <Box
              xcss={xcss({
                borderRightWidth: '2px',
                borderRightColor: 'color.border',
                borderRightStyle: 'solid',
                paddingRight: 'space.100',
              })}
            >
              <Text weight="bold">PayPal</Text>
            </Box>
            <Text color="color.text.subtlest">{emailID}</Text>
          </Inline>
        ) : (
          <Box>
            <Stack space="space.025" testId="paypal-email-id-stack-container">
              <Text weight="bold">PayPal</Text>
              <Text color="color.text.subtlest">{emailID}</Text>
            </Stack>
          </Box>
        )}
      </Inline>
    </Box>
  );
};

export const PaypalPaymentMethod: React.FC<PaypalProps> = ({
  emailID,
  renderChildrenInline,
  withBorder,
  isDesignIteration1Enabled,
  iconHeight,
  iconWidth,
}) => {
  return (
    <PaypalPanelWithPrimitives
      emailID={emailID}
      renderChildrenInline={renderChildrenInline}
      withBorder={withBorder}
      isDesignIteration1Enabled={isDesignIteration1Enabled}
      iconHeight={iconHeight}
      iconWidth={iconWidth}
    />
  );
};
